export default "__VITE_ASSET__8566857f__"